"use client";
import { Card, Badge, Row, Col, Stack } from "react-bootstrap";
import moment from "moment";
import { cal_holiday } from "../../class/prisma/db";
import { useI18n } from "../../i18n";

type DashboardEventCountProps = {
  holidays?: cal_holiday[];
};

function holidayNameFontSize(name: string): string {
  const midStringLength = 30;
  const largeStringLength = 43;

  if (name.length > largeStringLength) {
    return "0.99rem";
  }

  if (name.length > midStringLength) {
    return "1.10rem";
  }
  return "1.10rem";
}

function NextHoliday({ holidays }: DashboardEventCountProps) {
  const { t, locale } = useI18n();
  const map = new Map([
    ["en", "description"],
    ["zh-Hant", "description_zh"],
    ["zh-Hans", "description_cn"],
  ]);
  const key = map.get(locale) ?? "description_en";
  const descriptionKey = key as keyof cal_holiday;
  return (
    <Card
      style={{ width: "23rem", backgroundColor: "#f8f9fa", height: "170px" }}
    >
      <Card.Body>
        <Card.Subtitle className="mb-2 text-muted">{t("dashboard.nextHoliday")}</Card.Subtitle>

        <Card.Title
          style={{
            fontSize: "1.15rem",
            padding: "10px",
            paddingTop: 0,
            paddingLeft: 0,
          }}
        >
          {holidays &&
            holidays.length > 0 &&
            holidays.map((value, index) => (
              <Row>
                <Col
                  style={{
                    paddingRight: 0,
                    marginBottom: index !== holidays.length - 1 ? "10px" : 0,
                  }}
                >
                  <Stack
                    direction="horizontal"
                    style={{
                      maxHeight: "80px",
                      wordBreak: "break-word",
                      wordWrap: "break-word",
                      whiteSpace: "normal",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    <Badge
                      bg={"secondary"}
                      className="me-2 px-2"
                      style={{
                      }}
                    >
                      {moment(value.start_date).format("DD-MMM")}
                    </Badge>
                    <span
                      style={{
                        fontSize: "0.97rem",
                      }}
                    >
                      {value[descriptionKey]?.toString() ?? value.name}
                    </span>
                  </Stack>
                </Col>
              </Row>
            ))}
          {(!holidays || holidays.length === 0) && (
            <Col
              style={{
                textAlign: "center",
                paddingTop: 3,
                fontSize: "1.5rem",
              }}
            >
              <i>No Holiday...</i>
            </Col>
          )}
        </Card.Title>
      </Card.Body>
    </Card>
  );
}

export default NextHoliday;
